import TableCommonHook from '@op/components/TableCommonHook';
import useLanguage from '@op/hooks/useLanguage';
import { formatFilterDate } from '@op/utils/time';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';

export default function Index({
  data,
  columns: propsColumns = [],
  filter,
  formatValue = reviewsFormat,
}: {
  columns: Array<any>;
  data: Array<any>;
  filter: any;
  formatValue?: (value: number) => string | number;
}) {
  const { formatMessage } = useLanguage();
  const columns = useMemo(() => {
    const valueColumns = propsColumns.map((val) => {
      const { key } = val;
      return {
        ...val,
        header: formatMessage({ id: val.header }),
        render: (cvm: any) => formatValue(cvm[key]),
      };
    });

    return [
      {
        key: 'time',
        header: formatMessage({ id: 'Date' }),
        align: 'left',
        width: 130,
        render: (cvm: any) => formatFilterDate(cvm.time, filter),
      },
      ...valueColumns,
    ];
  }, [filter, propsColumns, formatMessage]);

  return (
    <TableCommonHook
      recordKey={'time'}
      columns={columns}
      records={data}
      minWidth={'auto'}
      maxHeight={310}
      hasPageable={false}
    ></TableCommonHook>
  );
}
